import Vue from "vue";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";
import PermissionsService from "@/core/services/permissions.service.ts";
import { sidebarBus } from "@/core/services/sidebar.service.ts";

@Component({})
export default class SidebarComponent extends Vue {
  isOpen: boolean = false;
  whatSubIsClicked: boolean = false;
  whereIAm: number = 0;
  isAdminClicked: boolean = false;
  isCompanyClicked: boolean = false;
  isSurveyClicked: boolean = false;
  isEvaluatedClicked: boolean = false;
  isSupportClicked: boolean = false;

  // Permissions list
  allPermissions: boolean = false;
  showSubMenuAdmins: boolean = true;
  showSubMenuCompanies: boolean = true;
  showSubMenuSurveys: boolean = true;
  showSubMenuEvaluateds: boolean = true;
  showSubMenuSupport: boolean = true;
  isTrainingSuperAdmin: boolean = false;
  isReporterRole: boolean = false;
  isSuperAdminRole: boolean = false;
  isAdminCfeRole: boolean = false;
  isReporterCfeRole: boolean = false;
  isCfeRole: boolean = false;
  companyPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  testPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  userAdminPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  rolePermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  surveyPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  questionPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  sectionPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  userCandidatePermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  skillPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  resourcePermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  profilePermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  supportPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  jobPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };
  businessPermissions: any = {
    get: false,
    post: false,
    put: false,
    delete: false,
  };

  created() {
    const _ = this;
    _.getPermissions();
  }

  mounted() {
    const _ = this;
    _.toKnowWhereIAm();
    _.checkToken();
    _.isTrainingAdmin();
    _.isReporter();
    _.isSuperAdmin();
    _.checkCfeRoles();
    sidebarBus.$on("sidebar:set", _.setSidebar);
    sidebarBus.$on("sidebar:toggle", _.toggleSidebar);
  }

  beforeDestroy() {
    const _ = this;
    sidebarBus.$off("sidebar:set", _.setSidebar);
    sidebarBus.$off("sidebar:toggle", _.toggleSidebar);
    _.lockBodyScroll(false);
  }

  @Watch("$route")
  onRouteChange() {
    this.setSidebar(false);
  }

  setSidebar(open: boolean) {
    const _ = this;
    _.isOpen = open;
    _.lockBodyScroll(open);
  }

  toggleSidebar() {
    const _ = this;
    _.setSidebar(!_.isOpen);
  }

  // The drawer overlays the page; without this the content keeps scrolling behind it.
  private lockBodyScroll(lock: boolean) {
    document.body.classList.toggle("sidebar-open", lock);
  }

  getPermissions() {
    const _ = this;
    // Esta linea saca los permisos de la compu
    let permissionSaved = JSON.parse(localStorage.getItem("permissions"));
    const companyId = localStorage.getItem("company");
    let {
      companyPermissions,
      businessPermissions,
      testPermissions,
      userAdminPermissions,
      rolePermissions,
      surveyPermissions,
      questionPermissions,
      sectionPermissions,
      userCandidatePermissions,
      skillPermissions,
      resourcePermissions,
      profilePermissions,
      supportPermissions,
      jobPermissions,
    } = this;
    let hasAllAdminPermissions,
      hasAllCompaniesPermissions,
      hasAllSurveysPermissions,
      hasAllEvaluatedsPermissions,
      hasAllSupportPermissions;

    if (permissionSaved.length == 1) {
      _.allPermissions = true;
      return;
    }
    for (let i = 0; i < permissionSaved.length; i++) {
      if (permissionSaved[i].endpoint.includes("company")) {
        companyPermissions.get = permissionSaved[i].get;
        companyPermissions.post = permissionSaved[i].post;
        companyPermissions.put = permissionSaved[i].put;
        companyPermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("business")) {
        businessPermissions.get = permissionSaved[i].get;
        businessPermissions.post = permissionSaved[i].post;
        businessPermissions.put = permissionSaved[i].put;
        businessPermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("test")) {
        testPermissions.get = permissionSaved[i].get;
        testPermissions.post = permissionSaved[i].post;
        testPermissions.put = permissionSaved[i].put;
        testPermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("admin")) {
        userAdminPermissions.get = permissionSaved[i].get;
        userAdminPermissions.post = permissionSaved[i].post;
        userAdminPermissions.put = permissionSaved[i].put;
        userAdminPermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("role")) {
        rolePermissions.get = permissionSaved[i].get;
        rolePermissions.post = permissionSaved[i].post;
        rolePermissions.put = permissionSaved[i].put;
        rolePermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("survey")) {
        surveyPermissions.get = permissionSaved[i].get;
        surveyPermissions.post = permissionSaved[i].post;
        surveyPermissions.put = permissionSaved[i].put;
        surveyPermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("question")) {
        questionPermissions.get = permissionSaved[i].get;
        questionPermissions.post = permissionSaved[i].post;
        questionPermissions.put = permissionSaved[i].put;
        questionPermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("section")) {
        sectionPermissions.get = permissionSaved[i].get;
        sectionPermissions.post = permissionSaved[i].post;
        sectionPermissions.put = permissionSaved[i].put;
        sectionPermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("candidate")) {
        userCandidatePermissions.get = permissionSaved[i].get;
        userCandidatePermissions.post = permissionSaved[i].post;
        userCandidatePermissions.put = permissionSaved[i].put;
        userCandidatePermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("skill")) {
        skillPermissions.get = permissionSaved[i].get;
        skillPermissions.post = permissionSaved[i].post;
        skillPermissions.put = permissionSaved[i].put;
        skillPermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("resource")) {
        resourcePermissions.get = permissionSaved[i].get;
        resourcePermissions.post = permissionSaved[i].post;
        resourcePermissions.put = permissionSaved[i].put;
        resourcePermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("profile")) {
        profilePermissions.get = permissionSaved[i].get;
        profilePermissions.post = permissionSaved[i].post;
        profilePermissions.put = permissionSaved[i].put;
        profilePermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("support")) {
        supportPermissions.get = permissionSaved[i].get;
        supportPermissions.post = permissionSaved[i].post;
        supportPermissions.put = permissionSaved[i].put;
        supportPermissions.delete = permissionSaved[i].delete;
      }
      if (permissionSaved[i].endpoint.includes("job")) {
        jobPermissions.get = permissionSaved[i].get;
        jobPermissions.post = permissionSaved[i].post;
        jobPermissions.put = permissionSaved[i].put;
        jobPermissions.delete = permissionSaved[i].delete;
      }
    }
    // Variables to show or hide a submenu item
    hasAllAdminPermissions =
      userAdminPermissions.get ||
      userAdminPermissions.post ||
      userAdminPermissions.put ||
      userAdminPermissions.delete ||
      rolePermissions.delete ||
      rolePermissions.post ||
      rolePermissions.put ||
      rolePermissions.get;

    hasAllCompaniesPermissions =
      companyPermissions.get ||
      companyPermissions.post ||
      companyPermissions.put ||
      companyPermissions.delete ||
      businessPermissions.delete ||
      businessPermissions.post ||
      businessPermissions.put ||
      businessPermissions.get;

    hasAllSurveysPermissions =
      surveyPermissions.get ||
      surveyPermissions.post ||
      surveyPermissions.put ||
      surveyPermissions.delete ||
      questionPermissions.get ||
      questionPermissions.post ||
      questionPermissions.put ||
      questionPermissions.delete ||
      resourcePermissions.get ||
      resourcePermissions.post ||
      resourcePermissions.put ||
      resourcePermissions.delete ||
      sectionPermissions.get ||
      sectionPermissions.post ||
      sectionPermissions.put ||
      sectionPermissions.delete ||
      skillPermissions.delete ||
      skillPermissions.post ||
      skillPermissions.put ||
      skillPermissions.get;

    hasAllEvaluatedsPermissions =
      userCandidatePermissions.get ||
      userCandidatePermissions.post ||
      userCandidatePermissions.put ||
      userCandidatePermissions.delete ||
      profilePermissions.get ||
      profilePermissions.post ||
      profilePermissions.put ||
      profilePermissions.delete ||
      jobPermissions.delete ||
      jobPermissions.post ||
      jobPermissions.put ||
      jobPermissions.get;

    hasAllSupportPermissions =
      supportPermissions.delete ||
      supportPermissions.post ||
      supportPermissions.put ||
      supportPermissions.get;

    if (!hasAllAdminPermissions) {
      _.showSubMenuAdmins = false;
    }

    if (
      !hasAllCompaniesPermissions ||
      (companyId !== null && companyId !== "1")
    ) {
      _.showSubMenuCompanies = false;
    }
    if (!hasAllSurveysPermissions) {
      _.showSubMenuSurveys = false;
    }
    if (!hasAllEvaluatedsPermissions) {
      _.showSubMenuEvaluateds = false;
    }
    if (!hasAllSupportPermissions) {
      _.showSubMenuSupport = false;
    }
  }

  isAdmin() {
    const _ = this;
    return localStorage.getItem("isAdmin") == "true";
  }

  checkToken() {
    const _ = this;
    if (localStorage.getItem("tk_auth") == null) {
      _.$router.push("/");
    }
  }

  toKnowWhereIAm() {
    const _ = this;
    let viewName: any = location.href.split("/");
    viewName = viewName[3];
    if (
      viewName == "admins" ||
      viewName == "roles" ||
      viewName == "reporters"
    ) {
      _.isAdminClicked = true;
    }
    if (viewName == "companies" || viewName == "business") {
      _.isCompanyClicked = true;
    }
    if (
      viewName == "survey" ||
      viewName == "questions" ||
      viewName == "question" ||
      viewName == "resource" ||
      viewName == "section" ||
      viewName == "skill" ||
      viewName == "table"
    ) {
      _.isSurveyClicked = true;
    }
    if (viewName == "evaluated" || viewName == "profile" || viewName == "job") {
      _.isEvaluatedClicked = true;
    }
    if (viewName == "support") {
      _.isSupportClicked = true;
    }
  }

  openSubmenu(position, status) {
    const _ = this;
    _.isAdminClicked = false;
    _.isCompanyClicked = false;
    _.isSurveyClicked = false;
    _.isEvaluatedClicked = false;
    _.isSupportClicked = false;
    switch (position) {
      case 0:
        if (status) {
          _.isAdminClicked = false;
          break;
        }
        _.isAdminClicked = true;
        break;
      case 1:
        if (status) {
          _.isCompanyClicked = false;
          break;
        }
        _.isCompanyClicked = true;
        break;
      case 2:
        if (status) {
          _.isSurveyClicked = false;
          break;
        }
        _.isSurveyClicked = true;
        break;
      case 3:
        if (status) {
          _.isEvaluatedClicked = false;
          break;
        }
        _.isEvaluatedClicked = true;
        break;
      case 4:
        if (status) {
          _.isSupportClicked = false;
          break;
        }
        _.isSupportClicked = true;
        break;
      default:
        break;
    }
  }

  private isTrainingAdmin() {
    const _ = this;
    const companyId = localStorage.getItem("company");
    if (companyId === "null" || companyId === "1") {
      _.isTrainingSuperAdmin = true;
    }
  }

  private isReporter() {
    const _ = this;
    const role = localStorage.getItem("role");
    if (role === "3") {
      _.isReporterRole = true;
    }
  }

  private isSuperAdmin() {
    const _ = this;
    const role = localStorage.getItem("role");
    _.isSuperAdminRole = role === "1";
  }

  private checkCfeRoles() {
    const _ = this;
    const role = localStorage.getItem("role");
    const companyId = localStorage.getItem("company");
    _.isAdminCfeRole = role === "5";
    _.isReporterCfeRole = role === "6";
    _.isCfeRole = _.isAdminCfeRole || _.isReporterCfeRole || companyId === "77";

    if (_.isCfeRole) {
      _.showSubMenuAdmins = false;
      _.showSubMenuCompanies = false;
      _.showSubMenuSurveys = false;
      _.showSubMenuSupport = false;
      _.showSubMenuEvaluateds = true;
    }
  }
}
